module.exports = __webpack_public_path__ + "img/dh.721e981d.png";